import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import SignatureCanvas from "react-signature-canvas";
import JobService from "../../Controller/JobController";
import HelpSite from "../../../Common/HelpLink";
import BASE_URL from "../../../../config/config";
import Swal from 'sweetalert2';
function AssetJobListPage(JobID) {
    JobID = localStorage.getItem('JobID');
    const navigate = useNavigate();
    const [formList, setForms] = useState([]);
    const [imagePreview, setImagePreview] = useState(null);
    const [ID, setID] = useState("0");
    const [isEditingSignature, setIsEditingSignature] = useState(false);
    const sigCanvas = useRef({});
    const [imageURL, setImageURL] = useState("");
    const CompanyID = localStorage.getItem("CompanyID");
    const fetchSignature = async (JobID) => {
        try {

            const data = await JobService.GetSignature(JobID);
            if (data.length > 0) {
                setImagePreview(data[0].Signature); // should be relative path
                setID(data[0].ID);
                setIsEditingSignature(false); // start in view mode
            } else {
                setIsEditingSignature(true); // allow drawing if no image
            }
        } catch (error) {
            console.error('Error fetching part images:', error);
        }
    };

    useEffect(() => {
        if (JobID > 0) {
            fetchSignature(JobID);
        }
    }, [JobID]);

    const clear = () => sigCanvas.current.clear();

    const save = async () => {
        const dataURL = sigCanvas.current.getCanvas().toDataURL("image/png");
        setImageURL(dataURL);

        const formData = {
            ID: ID,
            JobID: JobID,
            Signature: dataURL,
        };

        try {
            await JobService.CreateSignature(formData);

            Swal.fire(
                'Success',
                "Signature saved!",
                'success'
            );
            await fetchSignature(JobID);
            setIsEditingSignature(false); // go back to view mode
        } catch (err) {
            console.error("Upload error", err);
        }
    };
    const handleCompleteJob = async () => {


        try {
            await JobService.CompleteJob(JobID);
            navigate('/JobsListMobile');

        } catch (err) {
            console.error("Upload error", err);
        }
    };

    return (
        <div style={{ textAlign: "center" }}>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">
                            

                            {!isEditingSignature && imagePreview && (
                                <div>
                                    <img
                                        src={`${BASE_URL}/${imagePreview}`} // assuming relative path like "uploads/123/Job/Signature/..."
                                        alt="Saved Signature"
                                        style={{
                                            border: "1px dashed #999",
                                            borderRadius: "4px",
                                            background: "#fdfdfd",
                                            width: "100%",           // responsive
                                            maxWidth: "100%",        // no overflow
                                            height: "auto",
                                            margin: "10px auto",
                                            boxShadow: "0 0 0px rgba(0,0,0,0.1)",
                                            padding: 0,
                                        }}
                                    />
                                    <div style={{ marginTop: 10 }}>
                                        <button className="btn btn-warning" onClick={() => setIsEditingSignature(true)}>Edit Signature</button>
                                        <button className="btn btn-primary" style={{ "marginLeft": "5px" }} onClick={handleCompleteJob}>Complete</button>
                                    </div>
                                </div>
                            )}

                            {(isEditingSignature || !imagePreview) && (
                                <>
                                    <div
                                        style={{
                                            border: "1px dashed #999",
                                            borderRadius: "4px",
                                            background: "#fdfdfd",
                                            width: "100%",           // responsive
                                            maxWidth: "100%",        // no overflow
                                            height: "auto",
                                            margin: "10px auto",
                                            boxShadow: "0 0 0px rgba(0,0,0,0.1)",
                                            padding: 0,
                                        }}
                                    >
                                        <SignatureCanvas
                                            ref={sigCanvas}
                                            canvasProps={{
                                                style: {
                                                    width: "100%",    // take full container width
                                                    height: "150px", // fixed height works fine on mobile
                                                    backgroundColor: "#fff",
                                                    borderRadius: "4px",
                                                },
                                            }}
                                        />
                                    </div>
                                    <div style={{ marginTop: 10 }}>
                                        <button className="btn btn-secondary" onClick={clear}>Clear</button>{" "}
                                        <button className="btn btn-primary" onClick={save}>Save</button>

                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AssetJobListPage;